import config from "@/helpers/multidomain.helper";

export default{
    install(app){
        app.config.globalProperties.$appConfig = config
    }
}